import { useFeatureFlagsContext } from '@shared/core/featureFlags';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';

const ROOMBLOCK = 'roomblock';
const HOTEL_BOOKING = 'hotelbooking';

const HOTEL_BOOKING_ROUTE = `/:eventHandle/${HOTEL_BOOKING}`;
const HOTEL_BOOKING_ROUTES = {
  hotelbooking: HOTEL_BOOKING_ROUTE,
  roomblock: `${HOTEL_BOOKING_ROUTE}/${ROOMBLOCK}/:id`,
  partnerhotels: `${HOTEL_BOOKING_ROUTE}/partnerhotels/:hotelId`
} as const;

export const useHotelBookingRoutePaths = () => {
  const { formatToUrl } = useFeatureFlagsContext();
  const buildPath = useEventCallback((eventHandle: string, routePath: string, id?: string) => formatToUrl(`/${eventHandle}/${HOTEL_BOOKING}/${routePath}${id ? `/${id}` : ''}`));
  return {
    buildPath,
    roomblock: ROOMBLOCK,
    hotelBooking: HOTEL_BOOKING,
    hotelBookingRoute: HOTEL_BOOKING_ROUTE,
    hotelBookingRoutes: HOTEL_BOOKING_ROUTES
  };
};

type UtmParameters = {
  utm_medium: 'web' | 'email' | 'text';
  utm_source: string;
  utm_campaign: string;
  placeId?: string;
  name?: string;
  checkInDate?: string;
  checkOutDate?: string;
};

export const useHotelRoutePaths = () => {
  return {
    hotelSearch: {
      path: '/hotel/search',
      buildRelativeUrl: (eventHandle: string, utmParameters: UtmParameters) => {
        const params = new URLSearchParams(utmParameters);
        return `/${eventHandle}/hotel/search?` + params.toString();
      }
    },
    hotelDetails: {
      path: '/hotel/:joyPlaceId?',
      buildRelativeUrl: (eventHandle: string, joyPlaceId: string, utmParameters: UtmParameters) => {
        const params = new URLSearchParams(utmParameters);
        return `/${eventHandle}/hotel/${joyPlaceId}?` + params.toString();
      }
    }
  };
};
